var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productStatisticsWarp"},[_c('div',{staticClass:"productStatistics-top"},[_c('div',{staticClass:"productStatistics-top__left"},[_c('download-statistics-chart')],1),_c('div',{staticClass:"productStatistics-top__right"},[_c('class-statistic')],1)]),_c('div',{staticClass:"productStatistics-bottom"},[_c('TopTen')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }